export { ProductPurchase, type ProductPurchaseProps } from './ui/product-purchase';
